export default __webpack_public_path__ + "static/media/gilroy-regular.1d051d9d.eot";